import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    Tooltip
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from "yup";
import CSVReader from 'react-csv-reader';
import { confirmAlert } from 'react-confirm-alert';
import MaterialTable from "material-table";
import { Fragment } from 'react';
import { LoadingComponent } from '../../../utils/newLoader';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useAlert } from "react-alert";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    row: {
        marginTop: '1rem'
    }



}));

const screenCode = 'EMPLOYEEBULKUPLOAD';
export default function EmployeeBulkUpload(props) {
    const [title, setTitle] = useState("Employee Bulk Upload")
    const classes = useStyles();
    const alert = useAlert();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [divisions, setDivisions] = useState();
    const [routes, setRoutes] = useState();
    const [attendanceData, setAttendanceData] = useState([]);
    const [error, setError] = useState([]);
    const [customerData, setcustomerData] = useState([]);
    const [isDisableButton, setIsDisableButton] = useState(false);
    const [IsUploadingFinished, setIsUploadingFinished] = useState(false)
    const [attendanceBulkUpload, setAttendanceBulkUpload] = useState({
        groupID: '0',
        factoryID: '0',
        divisionID: '0',
        isBCardStatus: '',
        unionID: '0'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const handleClose = () => {
        setIsDisableButton(false);
        setOpen(false);
    };
    const [open, setOpen] = React.useState(true);
    const papaparseOptions = {
        header: true,
        dynamicTyping: false,
        quoteChar: '"',
        skipEmptyLines: true,
        parseNumbers: true,
        transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '')
    };
    const navigate = useNavigate();

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown()
        );
    }, [attendanceBulkUpload.groupID]);

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [attendanceBulkUpload.factoryID]);


    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEEBULKUPLOAD');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setAttendanceBulkUpload({
            ...attendanceBulkUpload,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }
    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(attendanceBulkUpload.groupID);
        setFactories(factory);
    }

    async function getDivisionsForDropDown() {
        const divisions = await services.getDivisionDetailsByEstateID(attendanceBulkUpload.factoryID);
        setDivisions(divisions);
    }

    const handleForce = (data, fileInfo) => {

        if (attendanceData.length > 0) {
            confirmAlert({
                title: 'Confirmation Message',
                message: 'Are you sure to browse a new file without uploading existing file.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => confirmUpload(data, fileInfo)
                    },
                    {
                        label: 'No',
                        onClick: () => handleClose()
                    }
                ],
                closeOnEscape: true,
                closeOnClickOutside: true,
            });

        }
        else {
            confirmUpload(data, fileInfo);
        }

    }

    function confirmUpload(data, fileInfo) {
        setIsUploadingFinished(false);
        setcustomerData(data);
        setAttendanceData(data);
    }

    async function saveEmployeeAttendance() {
        let errorCustomerList = [];
        let datarest = await Promise.all(attendanceData.map(async data => {

            var regnumberDuplicateCount = customerData.filter(a => a.registrationNumber === data.registrationNumber).length;
            var epfNoDuplicateCount = customerData.filter(a => a.epfNo === data.epfNo).length;
            if (regnumberDuplicateCount > 1) {
                errorCustomerList.push(data);
                return;
            }
            else if (epfNoDuplicateCount > 1) {
                errorCustomerList.push(data);
                return;
            }
            else if (data.registrationNumber.length === 0) {
                errorCustomerList.push(data);
                return;
            }
            else if (
                data.nic.length < 10 ||
                data.nic.length == 11 ||
                data.nic.length > 12
            ) {
                errorCustomerList.push(data);
                return;
            }
            else if (data.firstName === "") {
                errorCustomerList.push(data);
                return;
            }
            else if (data.isBCardStatus === "") {
                errorCustomerList.push(data);
                return;
            }
            else if (data.union === "") {
                errorCustomerList.push(data);
                return;
            }

            var employeeDetails = {
                employees: data,
                groupID: parseInt(attendanceBulkUpload.groupID),
                operationEntityID: parseInt(attendanceBulkUpload.factoryID),
                collectionPointID: parseInt(attendanceBulkUpload.divisionID),
                createdBy: parseInt(tokenDecoder.getUserIDFromToken())
            }
            const response = await services.SaveEmployeeBulkUpload(employeeDetails);
            if (response.statusCode == "Success") {
            }
            else {
                alert.error(response.message);
                errorCustomerList.push(data);
            }
        }))

        let totalCustomerDetailsCount = customerData.length;
        let totalFailedCustomerDetailsCount = errorCustomerList.length;
        let totalSubmitedCustomerDetailsCount = totalCustomerDetailsCount - totalFailedCustomerDetailsCount

        if (errorCustomerList.length === 0) {
            clearScreen()
            clearData();
            alert.success('All Employee details uploaded successfully');
        } else {
            document.querySelector('.csv-input').value = '';
            alert.info(totalSubmitedCustomerDetailsCount + ' record(s) uploaded successfully and ' + totalFailedCustomerDetailsCount + ' record(s) failed')
        }

        setAttendanceData(errorCustomerList);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }


    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        if (target.name === "groupID") {
            setAttendanceBulkUpload({
                ...attendanceBulkUpload,
                [e.target.name]: value,
                factoryID: 0
            });
        } else {
            setAttendanceBulkUpload({
                ...attendanceBulkUpload,
                [e.target.name]: value
            });
        }
        clearScreen();
    }

    function clearScreen() {
        setAttendanceData([]);
        document.querySelector('.csv-input').value = '';
    }

    function clearData() {
        setIsUploadingFinished(false);
        setAttendanceData([]);
        setAttendanceBulkUpload({
            ...attendanceBulkUpload,
            divisionID: '0',
            isBCardStatus: '',
        });
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: attendanceBulkUpload.groupID,
                            factoryID: attendanceBulkUpload.factoryID,
                            divisionID: attendanceBulkUpload.divisionID,
                            isBCardStatus: attendanceBulkUpload.isBCardStatus,
                            unionID: attendanceBulkUpload.unionID
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                divisionID: Yup.number().required('Division is required').min("1", 'Division is required'),
                            })
                        }
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={attendanceBulkUpload.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                            size='small'

                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={attendanceBulkUpload.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="divisionID">
                                                            Division *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.divisionID && errors.divisionID)}
                                                            fullWidth
                                                            helperText={touched.divisionID && errors.divisionID}
                                                            name="divisionID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={attendanceBulkUpload.divisionID}
                                                            variant="outlined"
                                                            id="divisionID"
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Division--</MenuItem>
                                                            {generateDropDownMenu(divisions)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink>
                                                            Select File *
                                                        </InputLabel>
                                                        <CSVReader
                                                            inputStyle={{ width: '100%', height: '56px' }}
                                                            cssClass="react-csv-input"
                                                            onFileLoaded={handleForce}
                                                            parserOptions={papaparseOptions}
                                                            inputId="react-csv-reader-input"
                                                            disabled={
                                                                attendanceBulkUpload.factoryID != 0 && attendanceBulkUpload.divisionID != 0 ? false : true
                                                            }
                                                        />
                                                        {attendanceBulkUpload.factoryID == 0 && attendanceBulkUpload.divisionID == 0 && (
                                                            <div style={{
                                                                color: "#f44336", marginLeft: "14px", marginRight: '14px', marginTop: "4px", fontSize: "0.75rem",
                                                                fontFamily: "Roboto"
                                                            }}>
                                                                Please select a Group, Estate & Division to enable file upload
                                                            </div>
                                                        )}
                                                    </Grid>
                                                </Grid>

                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="reset"
                                                        variant="outlined"
                                                        onClick={() => clearData()}
                                                        size='small'
                                                    >
                                                        Clear
                                                    </Button>
                                                </Box>
                                                <br />

                                                {attendanceData.length > 0 && IsUploadingFinished === true ?
                                                    <CardHeader style={{ marginLeft: '-1rem' }} titleTypographyProps={{ variant: 'h6' }}
                                                        title="Failed Records"
                                                    /> : null}

                                                <Box minWidth={1050}>
                                                    {attendanceData.length > 0 ?
                                                        <MaterialTable
                                                            title="Multiple Actions Preview"
                                                            columns={[
                                                                { title: 'Employee Type', field: 'employeeType' },
                                                                { title: 'Employee Category', field: 'employeeCategory' },
                                                                {
                                                                    title: 'Registration Number',
                                                                    field: 'registrationNumber',
                                                                    render: rowData => {
                                                                        var result = customerData.filter(
                                                                            a =>
                                                                                a.registrationNumber ===
                                                                                rowData.registrationNumber
                                                                        );
                                                                        if (result.length > 1) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip
                                                                                        title={
                                                                                            'Duplicate Registration Number.'
                                                                                        }
                                                                                    >
                                                                                        <span>
                                                                                            {'Duplicate Registration Number.'}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else if (rowData.registrationNumber.length === 0) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip
                                                                                        title={
                                                                                            'Invalid Registration Number.'
                                                                                        }
                                                                                    >
                                                                                        <span>
                                                                                            {'Invalid Registration Number.'}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            return rowData.registrationNumber;
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    title: 'First Name',
                                                                    field: 'firstName',
                                                                    render: rowData => {
                                                                        if (rowData.firstName === "") {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip title={'Name is Required'}>
                                                                                        <span>{'Name is Required'}</span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            return rowData.firstName;
                                                                        }
                                                                    }
                                                                },
                                                                { title: 'Gender', field: 'gender' },
                                                                //{ title: 'Union', field: 'union' },
                                                                //{ title: 'B Card Status', field: 'isBCardStatus' },
                                                                {
                                                                    title: 'EPF No',
                                                                    field: 'epfNo',
                                                                    render: rowData => {
                                                                        var result = customerData.filter(
                                                                            a =>
                                                                                a.epfNo == "" ? "" : a.epfNo === rowData.epfNo
                                                                        );
                                                                        if (result.length > 1) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip
                                                                                        title={
                                                                                            'Duplicate EPF Number.'
                                                                                        }
                                                                                    >
                                                                                        <span>
                                                                                            {'Duplicate EPF Number.'}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            return rowData.epfNo;
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    title: 'NIC',
                                                                    field: 'nic',
                                                                    render: rowData => {
                                                                        var result = customerData.filter(
                                                                            a => a.nic === rowData.nic
                                                                        );

                                                                        if (
                                                                            rowData.nic.length < 10 ||
                                                                            rowData.nic.length == 11 ||
                                                                            rowData.nic.length > 12
                                                                        ) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip title={'Invalid NIC.'}>
                                                                                        <span>{'Invalid NIC.'}</span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else if (result.length > 1) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: '#ffcdd2',
                                                                                        padding: '10px',
                                                                                        borderRadius: '5px'
                                                                                    }}
                                                                                >
                                                                                    <Tooltip title={'Duplicate NIC.'}>
                                                                                        <span>{'Duplicate NIC.'}</span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            return rowData.nic;
                                                                        }
                                                                    }
                                                                },
                                                                { title: 'Religion', field: 'religion' },
                                                                { title: 'Mobile Number', field: 'mobileNumber' },
                                                            ]}
                                                            data={attendanceData}
                                                            options={{
                                                                exportButton: false,
                                                                showTitle: false,
                                                                headerStyle: { textAlign: "left", height: '1%' },
                                                                cellStyle: { textAlign: "left" },
                                                                columnResizable: false,
                                                                actionsColumnIndex: -1,
                                                                pageSize: 5
                                                            }}
                                                            actions={[

                                                            ]}
                                                        /> : null}
                                                </Box>
                                                {attendanceData.length > 0 ?
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            variant="contained"
                                                            onClick={() => (trackPromise(saveEmployeeAttendance()))}
                                                        >
                                                            Upload
                                                        </Button>
                                                    </Box> : null}
                                            </CardContent>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    )

}
